import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";
import { api, errMsg } from "../../lib/api";

export const DeleteDialog = ({ item, cat, onClose, onDeleted }) => {
  const title = item ? item.data[cat.list[0]] || item.data[cat.list[1]] || "data ini" : "";
  const confirm = async () => {
    try {
      await api.delete(`/items/${cat.key}/${item.item_id}`);
      toast.success("Data dihapus");
      onDeleted();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <AlertDialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent className="rounded-sm" data-testid="delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">Hapus data?</AlertDialogTitle>
          <AlertDialogDescription>"{title}" akan dihapus permanen dari {cat.label}.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-cancel">Batal</AlertDialogCancel>
          <AlertDialogAction onClick={confirm} className="bg-rose-600 hover:bg-rose-700" data-testid="delete-confirm">Hapus</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
